/**
 * Navigation Registry
 * Provides a centralized way for services to request navigation
 * without directly coupling to GameController
 */

type NavigationFunction = (pageId: string, props?: any) => void;

class NavigationRegistry {
  private navigationFn: NavigationFunction | null = null;

  /**
   * Register the navigation function (called by GameController)
   */
  register(navigationFn: NavigationFunction): void {
    this.navigationFn = navigationFn;
  }

  /**
   * Unregister the navigation function
   */
  unregister(): void {
    this.navigationFn = null;
  }

  /**
   * Request navigation to a page
   * @param pageId The page ID to navigate to
   * @param props Optional props to pass to the page
   */
  navigateToPage(pageId: string, props?: any): void {
    if (!this.navigationFn) {
      console.warn('[NavigationRegistry] Navigation requested but no navigation function registered:', pageId);
      return;
    }
    this.navigationFn(pageId, props);
  }
}

// Export singleton instance
export const navigationRegistry = new NavigationRegistry();
